import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { DownloadableConfigurationFiles } from '../../../_lib/components/ConfigurationFileUpload';

type UserRegistrationPresetsDefaultProps = { fileExtension: 'yaml' | 'json'; url: string };

function UserRegistrationPresetsDefault(file: UserRegistrationPresetsDefaultProps) {
  const { uuid, elementType } = useBlockContext();
  const { t } = useSonTranslation('UserRegistrationPresets');
  return (
    <DownloadableConfigurationFiles
      key={`${elementType}-${uuid}`}
      files={[
        {
          extension: file.fileExtension,
          url: file.url,
          name: t('filename'),
        },
      ]}
    />
  );
}

export const UserRegistrationPresetsDefaultView = asView(UserRegistrationPresetsDefault);
export type UserRegistrationPresetsDefaultView = ComponentProps<typeof UserRegistrationPresetsDefaultView>;
